var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { capitalize } from '@mui/material';
import { getClassifierNames } from './getClassifierNames';
import { getEclLabelByValue } from './getEclLabelByValue';
import { getStateNameByPostalCode } from './getStateNameByPostalCode';
export function mapDataToCsvRow(response, withTrainCourses) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const ecls = (_a = response.data.ecl) === null || _a === void 0 ? void 0 : _a.map((ecl) => getEclLabelByValue(ecl)).join(',');
        return [
            response.id,
            response.data.name,
            capitalize(response.data.status),
            yield getClassifierNames('occupationGroup', response.data.groupIds),
            yield getClassifierNames('occupation', response.data.occupationIds, ';'),
            response.data.allOccupations ? 'yes' : 'no',
            (_b = response.data.description) !== null && _b !== void 0 ? _b : '',
            ecls !== null && ecls !== void 0 ? ecls : '',
            yield getClassifierNames('skill', response.data.skillIds),
            yield getClassifierNames('training', response.data.trainingIds),
            ...(withTrainCourses ? [yield getClassifierNames('trainCourse', response.data.trainCourseIds)] : []),
            yield getClassifierNames('language', response.data.languageIds),
            yield getStateNameByPostalCode(response.data.state),
            response.data.counties ? response.data.counties.join(',') : '',
            yield getClassifierNames('tribe', response.data.tribeIds),
            yield getClassifierNames('deploymentDuration', response.data.deploymentDurationId),
            yield getClassifierNames('deploymentTravelWillingness', response.data.deploymentTravelWillingnessIds),
            response.data.federalDeploymentWillingness ? (response.data.federalDeploymentWillingness ? 'yes' : 'no') : '',
            response.data.priorCommitments ? (response.data.priorCommitments ? 'yes' : 'no') : '',
        ];
    });
}
